import React from 'react'

export const About = () => {
    let mystyle = {
        height:"47vh",
        padding:"40px",
        color:"white",
        textAlign:"center"

    }
    return (
        <div style={mystyle}>
            <h1>About us</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque laborum enim adipisci sapiente expedita modi voluptas vitae debitis incidunt perspiciatis, consequatur iste, recusandae maxime fugiat dignissimos! Culpa dolorem voluptate tempora excepturi aspernatur at, corporis error, iure earum mollitia, quis rem neque repellendus. Ipsam, ad labore voluptatem dolores ab nemo rerum. ,Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit voluptate laudantium cum voluptatem doloremque tempore inventore saepe. Libero, quam nostrum aliquid totam quod minima enim quia ipsum repudiandae non nemo distinctio illum eius ipsam corrupti porro soluta deserunt suscipit ullam hic laudantium! Consectetur nesciunt ipsam neque ex ipsa iure corrupti aut sequi aspernatur mollitia minima, suscipit soluta cumque, quam quibusdam, nobis rerum distinctio porro. Ipsa pariatur, doloribus optio iure dicta velit officia neque aliquam quidem tempore, aliquid voluptate autem nulla, explicabo labore nesciunt possimus et ut? Consequuntur, ad laborum nam, vel enim impedit saepe molestiae autem libero aspernatur dolore accusamus?
            </p>
        </div>
    )
}
